import { DUPLICATED_PAYMENT_ERROR } from 'constants/errors';
import { UPDATE_ORDER_FAILURE, UPDATE_ORDER_SUCCESS } from 'constants/orders';
import { CLOSE_DUPLICATED_TAX_PAYMENT_MODAL } from 'constants/ui';
import type { ApiError } from 'models/error';
import { combineReducers } from 'redux';

type DuplicatedTaxPayment =
  | {
      type:
        | typeof CLOSE_DUPLICATED_TAX_PAYMENT_MODAL
        | typeof UPDATE_ORDER_SUCCESS;
    }
  | {
      type: typeof UPDATE_ORDER_FAILURE;
      payload: {
        entities: {
          errors: Record<string, ApiError>;
        };
      };
    };

export const isVisible = (state = false, action: DuplicatedTaxPayment) => {
  switch (action.type) {
    case UPDATE_ORDER_SUCCESS:
    case CLOSE_DUPLICATED_TAX_PAYMENT_MODAL:
      return false;
    case UPDATE_ORDER_FAILURE:
      const { entities: { errors = {} } = {} } = action.payload;
      const error = errors.offer_pan_number;

      return error?.type === DUPLICATED_PAYMENT_ERROR;
    default:
      return state;
  }
};

const duplicatedTaxPayment = combineReducers({ isVisible });

export { duplicatedTaxPayment };
